
/**
 * Module dependencies.
 */

import { Button, Heading, MaskedIcon, Text } from 'slyk-web-libs/design-system';
import { Helmet } from 'react-helmet';
import { MainContent } from 'client/components/layouts/page-layout';
import { color, media } from 'react-components/styles';
import { useTranslate } from 'slyk-web-libs/i18n';
import React from 'react';
import emailValidatedSvg from 'client/assets/svg/140/email-validated.svg';
import routes from 'slyk-web-libs/config/payspace-routes';
import styled from 'styled-components';

/**
 * `Content` styled component.
 */

const Content = styled.div` 
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  text-align: center;
`;

/**
 * `StyledMaskedIcon` styled component.
 */

const StyledMaskedIcon = styled(MaskedIcon)`
  align-self: center;
  margin-bottom: 24px;
`;

/**
 * `Title` styled component.
 */

const Title = styled(Heading).attrs({ as: 'h1' })` 
  color: ${color('primary')};
  margin-bottom: 24px;

  ${media.min('md')`
    margin-bottom: 40px;
  `}
`;

/**
 * `Description` styled component.
 */

const Description = styled(Text)` 
  color: ${color('gray500')};
  margin-bottom: 24px;
`;

/**
 * Export `ResetPasswordSuccess` container.
 */

export function ResetPasswordSuccess(): JSX.Element {
  const { translate } = useTranslate();
  const title = translate('resetPasswordSuccess.title');

  return (
    <>
      <Helmet>
        <title>
          {title}
        </title>
      </Helmet>

      <MainContent>
        <Content>
          <Title>
            {title}
          </Title>

          <StyledMaskedIcon
            color={color('primary')}
            icon={emailValidatedSvg}
          />

          <Description>
            {translate('resetPasswordSuccess.description')}
          </Description>

          <Button
            size={'large'}
            to={routes.home}
          >
            {translate('resetPasswordSuccess.successButton')}
          </Button>
        </Content>
      </MainContent>
    </>
  );
}
